var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        {
          ref: "searchbox",
          attrs: { isShowSearch: false },
          on: { enter: _vm.getList },
        },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  on: { datachange: _vm.getList },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("c-table", {
        ref: "processTable",
        attrs: {
          merge: _vm.grid.merge,
          columns: _vm.grid.columns,
          data: _vm.grid.data,
          gridHeight: _vm.grid.height,
          filtering: true,
          columnSetting: false,
          isFullScreen: false,
          isTitle: false,
          selection: _vm.popupParam.type,
          rowKey: "processCd",
        },
      }),
      _c("div", { staticClass: "space-bottom-button" }),
      _c(
        "div",
        { staticClass: "search-box-btn" },
        [
          _c(
            "q-btn-group",
            { attrs: { outline: "" } },
            [
              _c("c-btn", {
                attrs: { label: "검색", icon: "search" },
                on: { btnClicked: _vm.getList },
              }),
              _c("c-btn", {
                attrs: { label: "선택", icon: "check" },
                on: { btnClicked: _vm.select },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }